if ($(".article-sidebar--min").length) {
    let button = $(".article-sidebar__top__title__icon"),
        list = $(".article-sidebar__top__list");

    button.click(function(){
        button.toggleClass("is-active");
        list.toggleClass("is-active").slideToggle();
    })

    $(document).mouseup(function(e) {
        if (list.hasClass("is-active")) {
          if (!button.is(e.target) && 
              button.has(e.target).length === 0 &&
              !list.is(e.target) && 
              list.has(e.target).length === 0) {
                button.removeClass("is-active");
                list.removeClass("is-active").slideUp();
          }
        }
    })
}